















































































































































































































import { Component, Vue } from "vue-property-decorator";
import { BIcon, BIconArrowRight, BIconBoxArrowRight } from "bootstrap-vue";
@Component({
  components: {
    BIcon,
    BIconArrowRight,
    BIconBoxArrowRight
  }
})
export default class DefEvolution extends Vue {}
